import api from '../api'

export default api.resource({
  path    : 'applications',
  keyName : 'id'
})
